import React, { useState, useEffect } from "react";
import { db } from "../../fbserve";
import {
  collection,
  getDocs,
  doc,
  deleteDoc,
  orderBy,
  query,
} from "firebase/firestore";

const ListEmails = () => {
  const emailsRef = collection(db, "josscontacts");
  const qp = query(emailsRef, orderBy("datecode", "desc"));

  const [emails, setEmails] = useState([] as Array<any> | null);
  const [editEmail, setEditEmail] = useState(false);
  const [emailIndex, setEmailIndex] = useState(0);
  const [showEmailList, setShowEmailList] = useState(false);

  const getEmails = async () => {
    const siteemails = [] as Array<any>;
    const querySnapshot = await getDocs(qp);
    querySnapshot.forEach((doc: any) => {
      siteemails?.push({ ...doc.data(), id: doc.id });
    }) as unknown as any[];
    setEmails(siteemails);
  };

  useEffect(() => {
    getEmails();
  });

  const setEditEmailClose = () => {
    setEditEmail(false);
  };

  const emailEditCard = (i: number) => {
    const nextState = i;
    setEditEmail(true);
    setEmailIndex(nextState);
  };

  const startEmailList = () => {
    setShowEmailList((prev) => !prev);
  };

  const delEmail = async (ev: any, id: string) => {
    ev.preventDefault();
    const confirmDel = window.confirm(
      `This cannot be undone: Are You Sure You Want to Delete this email from ${emails?.[emailIndex]?.name}?`
    );
    if (confirmDel) {
      await deleteDoc(doc(db, "josscontacts", `${id}`));
      const setTime = setTimeout(() => {
        getEmails();
        emailEditCard(0);
      }, 3300);
      return () => {
        clearTimeout(setTime);
      };
    }
  };

  return (
    <div style={{ borderTop: "1px solid white", paddingTop: "1rem" }}>
      {editEmail ? (
        <div className="editdiv">
          <h4 style={{ marginTop: "0.5rem", marginBottom: "0" }}>Editing: </h4>

          <ol>
            <li>
              <strong>name:</strong> {emails?.[emailIndex]?.name}
            </li>
            <li>
              <strong>email:</strong> {emails?.[emailIndex]?.email}
            </li>
            <li>
              <strong>message:</strong> {emails?.[emailIndex]?.message}
            </li>
            <li>
              <strong>datetime:</strong> {emails?.[emailIndex]?.datetime}
            </li>
          </ol>

          <div style={{ display: "flex", alignItems: "baseline" }}>
            <p>
              <strong>ID:</strong> {emails?.[emailIndex]?.id}
            </p>
            <button
              className="btn"
              onClick={(ev) => delEmail(ev, emails?.[emailIndex]?.id)}
            >
              Delete
            </button>
          </div>
          <button className="btn" onClick={setEditEmailClose}>
            Close
          </button>
        </div>
      ) : null}
      <button className="btn btnheading" onClick={startEmailList}>
        {showEmailList ? `Hide Emails` : `Show ${emails.length} Emails`}
      </button>
      {showEmailList ? (
        <div>
          <div
            style={{
              borderTop: "1px solid white",
              paddingTop: "1rem",
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            {emails?.map((mail: any, i: number) => (
              <button
                key={i}
                style={{
                  margin: "0.36rem",
                  display: "flex",
                  flexDirection: "column",
                }}
                className="btn"
                onClick={() => {
                  emailEditCard(i);
                }}
              >
                <strong>{mail.name}</strong>
                <span>{mail.email}</span>
              </button>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default ListEmails;
